import { SubmitState } from 'consts';

export const setSubmitState = (state, submitState) => {
  return { submitState: submitState || SubmitState.NotReady };
};
